/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Categories_DeletedInputs */

const en_admin_categories_deleted = /** @type {(inputs: Admin_Categories_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Category deleted`)
};

const zh_admin_categories_deleted = /** @type {(inputs: Admin_Categories_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分类已删除`)
};

/**
* | output |
* | --- |
* | "Category deleted" |
*
* @param {Admin_Categories_DeletedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_categories_deleted = /** @type {((inputs?: Admin_Categories_DeletedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Categories_DeletedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_categories_deleted(inputs)
	return zh_admin_categories_deleted(inputs)
});
export { admin_categories_deleted as "admin.categories.deleted" }